module.exports = __webpack_public_path__ + "img/city-1.3d2c0dc9.jpeg";